module.exports = __webpack_public_path__ + "img/6H.d31f2d06.png";